import { render, staticRenderFns } from "./UserWalletTransactionTable.vue?vue&type=template&id=66f700e1&"
import script from "./UserWalletTransactionTable.vue?vue&type=script&lang=js&"
export * from "./UserWalletTransactionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports